// extracted by mini-css-extract-plugin
module.exports = {"paper":"Paper_paper__36swt","noMargin":"Paper_noMargin__QoXQp","noPadding":"Paper_noPadding__A_LsY"};